import { ArrowRight, MessageCircle, MapPin } from "lucide-react";
import { openWhatsApp } from "../../lib/whatsapp";

const HERO_IMG =
  "https://static.prod-images.emergentagent.com/jobs/10165ba5-237c-4471-8603-ea6dbde73886/images/29bc78d7175b9f998f8de1ef1d471d29f39a9d662ae8bdc070fe8ab0c3121ca3.png";

export const Hero = () => {
  return (
    <section
      id="top"
      data-testid="section-hero"
      className="relative min-h-[100vh] flex items-center overflow-hidden"
    >
      {/* Background image */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${HERO_IMG})` }}
        aria-hidden
      />
      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-black via-black/85 to-black/30" />
      <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent" />

      {/* Diagonal accent line */}
      <div className="absolute right-0 top-0 bottom-0 w-1.5 diag-divider opacity-70" />

      <div className="relative w-full max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 pt-32 pb-20">
        <div className="max-w-3xl">
          <p className="inline-flex items-center gap-2 text-xs sm:text-sm text-[#FF5A1F] uppercase tracking-[0.25em] font-bold mb-6">
            <span className="w-8 h-px bg-[#FF5A1F]" />
            Nutrición & Entrenamiento · Pamplona
          </p>

          <h1
            data-testid="hero-headline"
            className="font-display font-black uppercase text-white text-5xl sm:text-6xl lg:text-7xl leading-[0.9] tracking-tighter"
          >
            Pierde <span className="text-[#FF5A1F]">7-20 kg</span> y vuelve a
            disfrutar de tu familia
          </h1>

          <p className="mt-6 text-lg sm:text-xl text-zinc-300 max-w-2xl leading-relaxed">
            Recupera tu energía, mejora tu salud y transforma tu cuerpo sin
            dietas restrictivas. Un método directo para hombres +35 que están
            listos para el <span className="text-white font-semibold">CAMBIO</span>.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <button
              data-testid="hero-cta-whatsapp"
              onClick={() =>
                openWhatsApp(
                  "Hola Aitor, vi tu web y quiero empezar mi CAMBIO. ¿Hablamos?"
                )
              }
              className="group inline-flex items-center justify-center gap-3 bg-[#FF5A1F] hover:bg-[#E04814] transition-colors text-white font-bold uppercase tracking-wider px-8 py-4 text-base"
            >
              <MessageCircle size={20} />
              Hablar por WhatsApp
              <ArrowRight
                size={18}
                className="group-hover:translate-x-1 transition-transform"
              />
            </button>

            <a
              href="#metodo"
              data-testid="hero-cta-method"
              className="inline-flex items-center justify-center gap-2 border-2 border-zinc-700 hover:border-white text-white font-bold uppercase tracking-wider px-8 py-4 text-base transition-colors"
            >
              Ver el método
            </a>
          </div>

          {/* Trust strip */}
          <div className="mt-14 grid grid-cols-3 gap-6 max-w-xl border-t border-zinc-800 pt-8">
            <div>
              <p className="font-display text-3xl sm:text-4xl font-black text-white">
                +120
              </p>
              <p className="text-xs uppercase tracking-widest text-zinc-500 mt-1">
                Hombres transformados
              </p>
            </div>
            <div>
              <p className="font-display text-3xl sm:text-4xl font-black text-[#FF5A1F]">
                7-20<span className="text-zinc-600 text-xl">kg</span>
              </p>
              <p className="text-xs uppercase tracking-widest text-zinc-500 mt-1">
                Pérdida media
              </p>
            </div>
            <div>
              <p className="font-display text-3xl sm:text-4xl font-black text-white">
                100%
              </p>
              <p className="text-xs uppercase tracking-widest text-zinc-500 mt-1">
                Plan personalizado
              </p>
            </div>
          </div>

          <p className="mt-10 inline-flex items-center gap-2 text-zinc-500 text-sm">
            <MapPin size={14} className="text-[#FF5A1F]" /> C/ Berriobide ·
          Pamplona · Online & Presencial
          </p>
        </div>
      </div>
    </section>
  );
};
